// src/stores/authStore.js
import { defineStore } from 'pinia'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { fetchUserData } from '../assets/js/gameSearchJs'; 

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isSignedIn: false,
    email: '',
    isAuthReady: false,
    userid: '',
    userInfos: null,
    isLoading: true,
    role: ''
  }),
  actions: {
    setSignedIn(status, email = '') {
      this.isSignedIn = status,
      this.email = email,
      this.userid = status ? this.userid : '',
      this.isAuthReady = true
    },
    async initAuth() {
      const auth = getAuth()
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          this.userid = user.uid
          this.setSignedIn(true, user.email)
          try {
            this.userInfos = await fetchUserData(this.userid)
          } catch (error) {
            console.error('Error fetching user data:', error)
          }
        } else {
          this.setSignedIn(false)
        }
        this.isLoading = false
      })
    },
    async mutate() {
        try {
            this.userInfos = await fetchUserData(this.userid)
        } catch (error) {
            console.error('Error fetching user data:', error)
        }
    }
  },
})
